import { normalizeAppName } from './appAccess';

export function normalizeClaims(claims) {
  const c = claims || {};

  let apps = [];
  if (Array.isArray(c.apps)) {
    apps = c.apps.map((x) => normalizeAppName(x));
  } else if (typeof c.apps === 'string') {
    try {
      const parsed = JSON.parse(c.apps);
      if (Array.isArray(parsed)) apps = parsed.map((x) => normalizeAppName(x));
    } catch (e) {
      apps = String(c.apps)
        .split(',')
        .map((x) => normalizeAppName(x.trim()))
        .filter(Boolean);
    }
  }

  const role = String(c.onTimeRole || c.role || '').toLowerCase();
  const defaultApp = normalizeAppName(c.defaultApp || '');
  const isSuper = c?.superAdmin === true || c?.superadmin === true;
  const orgId = c?.orgId ? String(c.orgId) : '';
  const orgAdmin = c?.orgAdmin === true || c?.orgadmin === true;

  return { ...c, apps, role, defaultApp, isSuper, orgId, orgAdmin };
}

function getActiveAppHint(options = {}) {
  return normalizeAppName(options?.preferredApp || options?.activeAppHint || '');
}

function hasAny(c, aliases) {
  return c.apps.some((app) => aliases.includes(app)) || aliases.includes(c.defaultApp);
}

function hasExplicitApp(c, aliases) {
  return c.isSuper || c.apps.some((app) => aliases.includes(app)) || aliases.includes(c.defaultApp);
}

export function getLandingPath(claims, options = {}) {
  const c = normalizeClaims(claims);
  const activeAppHint = getActiveAppHint(options);

  if (c.isSuper) return '/super';
  if (!c.orgId) return '/no-access';

  const hasCashup = hasExplicitApp(c, ['neo', 'cashup', 'neo_admin', 'admin']);
  const hasOnTime = hasExplicitApp(c, ['ontime', 'link']);
  const hasInvoice = hasExplicitApp(c, ['invoice', 'dashboard']);
  const hasMorpheus = hasExplicitApp(c, ['mc', 'morpheus', 'morpheus-count', 'morphius']);

  if (activeAppHint === 'mc' && hasMorpheus) return '/morpheus-count/workspace';
  if (activeAppHint === 'ontime' && hasOnTime) {
    if (String(c.role || '').includes('store')) return '/ontime/store';
    if (String(c.role || '').includes('driver')) return '/ontime/driver';
    return '/ontime';
  }
  if (activeAppHint === 'neo' && hasCashup) return '/cashup';
  if (activeAppHint === 'invoice' && hasInvoice) return '/dashboard';

  if (c.defaultApp === 'mc' && hasMorpheus) return '/morpheus-count/workspace';
  if (c.defaultApp === 'ontime' && hasOnTime) {
    if (String(c.role || '').includes('store')) return '/ontime/store';
    if (String(c.role || '').includes('driver')) return '/ontime/driver';
    return '/ontime';
  }
  if (c.defaultApp === 'neo' && hasCashup) return '/cashup';
  if (['invoice', 'dashboard'].includes(c.defaultApp) && hasInvoice) return '/dashboard';

  if (hasCashup) return '/cashup';
  if (hasMorpheus) return '/morpheus-count/workspace';
  if (hasOnTime) {
    if (String(c.role || '').includes('store')) return '/ontime/store';
    if (String(c.role || '').includes('driver')) return '/ontime/driver';
    return '/ontime';
  }
  if (hasInvoice) return '/dashboard';
  return '/no-access';
}
